export const getTextColorByVoltageKey = (key: string | null | undefined) => {
  switch (key) {
    case '1': // 16kv
      return 'text-tc-turquoise';
    case '2': // 50kv
      return 'text-tc-red';
    case '3': // 110kv
      return 'text-tc-orange';
    case '4': // 220kv
      return 'text-tc-green';
    case '5': //380kv
      return 'text-tc-violet';
    case '6': //64kv
      return 'text-dark-yellow';
    case '7': //132kv
      return 'text-success';
    default:
      return 'text-text-primary';
  }
};
